import { render, staticRenderFns } from "./ComInput.vue?vue&type=template&id=2af33520&scoped=true&"
import script from "./ComInput.vue?vue&type=script&lang=js&"
export * from "./ComInput.vue?vue&type=script&lang=js&"
import style0 from "./ComInput.vue?vue&type=style&index=0&id=2af33520&prod&lang=scss&scoped=true&"
import style1 from "./ComInput.vue?vue&type=style&index=1&id=2af33520&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af33520",
  null
  
)

export default component.exports